<template>
  <div id="app">
    <div class="global-scroll-container">
      <el-container class="global-container">
        <div class="header-group" v-if="!$route.meta.hiddenHeader">
          <el-header class="main-header">
            <top-bar></top-bar>

          </el-header>

          <el-header v-if="!isMobile" class="header-pc">
            <main-nav></main-nav>
          </el-header>
          <el-header v-else style="padding:  0;">
            <main-nav></main-nav>
          </el-header>

        </div>
        <el-main v-if="!isMobile" class="main-content-pc">
          <div class="breadcrumb" v-if="$route.path !== '/' && !$route.path.includes('/events/sign-in/')">
            当前位置：
            <template v-for="(item, index) in breadcrumbItems">
              <span :key="index">{{ item.name }}</span>
              <span v-if="index < breadcrumbItems.length - 1" class="separator" :key="'sep-' + index">/</span>
            </template>
          </div>
          <router-view v-slot="{ Component }">
            <transition name="fade-transform" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </el-main>
        <el-main v-else class="main-content">
          <router-view v-slot="{ Component }">
            <transition name="fade-transform" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </el-main>

        <!-- 底部区域 -->
        <el-footer class="main-footer" style="padding:  0;" v-if="!$route.meta.hiddenFooter">
          <footer-bar />
        </el-footer>
      </el-container>

    </div>

    <!-- 悬浮按钮，在签到页面始终不显示 -->
    <div class="floating-buttons" v-show="showAllBtn">
      <div class="floating-div" @click="goToRegistration">
        <img src="@/assets/home/home_entry.png" alt="">
        <p>博鳌报名</p>
      </div>
      <div class="floating-div" @click="goToVip">
        <img src="@/assets/home/home_vip.png" alt="">
        <p>会员专区</p>
      </div>
      <div class="floating-div" @click.stop="scrollToTop">
        <img src="@/assets/home/home_scroll.png" alt="">
        <p>回到顶部</p>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import TopBar from './components/TopBar.vue';
import MainNav from './components/MainNav.vue';
import FooterBar from './components/FooterBar.vue';
import { mapActions } from 'vuex';
import { ACCESS_TOKEN, USER_NAME, USER_INFO, Cache } from "@/store/mutation-types"


export default {
  name: 'App',
  components: {
    TopBar,
    MainNav,
    FooterBar
  },
  data() {
    return {
      isMobile: false,
      showAllBtn: false,
      breadcrumbItems: [],
      hasCheckedUserInfo: false, // 添加标记，记录是否已经检查过用户信息
      breadcrumbMap: {
        news: { name: '新闻中心', link: '/news' },
        announcements: { name: '通知公告', link: '/news/announcements' },
        info: { name: '新闻资讯', link: '/news/info' },
        future: { name: '职教未来', link: '/news/future' },
        detail: {
          name: '详情',
          getParent: (path) => {
            if (path.includes('/news/announcements')) return 'announcements';
            if (path.includes('/news/info')) return 'info';
            if (path.includes('/news/future')) return 'future';
            return '';
          }
        },
      }
    }
  },
  async mounted() {
    this.checkMobile();
     window.addEventListener('resize', this.checkMobile);
    let isSign=window.location.pathname.includes('/events/sign-in/');
   
    if(isSign){
      return;
    }
    this.updateBreadcrumb();
    this.checkAndRefreshUserInfo();
   
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },

  computed: {

    mainClass() {
      return {
        'full-height': this.$route.meta?.fullHeight,
        'auto-height': !this.$route.meta?.fullHeight
      }
    },
    contentPadding() {
      return {
        'padding-left': this.isMobile ? '15px' : '300px',
        'padding-right': this.isMobile ? '15px' : '300px',
        'padding-top': 0
      }
    }
  },
  watch: {
    '$route': {
      handler(newRoute) {
        this.updateBreadcrumb();
        // 在登录、注册和签到页面隐藏浮动按钮
        this.showAllBtn = !['/user/login', '/user/register','/registration/form'].includes(newRoute.path) && !newRoute.path.includes('/events/sign-in/');

        // 添加路由变化时的翻译处理
        const savedTranslateLang = localStorage.getItem('translate_lang');
        if (savedTranslateLang == 'english' && window.translate) {
          setTimeout(() => {
            window.translate.execute();
          }, 100);
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    async checkAndRefreshUserInfo() {
      if (this.hasCheckedUserInfo) return;

      const token = Cache.get(ACCESS_TOKEN)
      if (token) {
        try {
          await this.GetUserInfo()
        } catch (error) {
          console.error('刷新用户信息失败:', error)
        }
      }
      this.hasCheckedUserInfo = true; // 标记已经检查过
    },
    checkMobile() {

      this.isMobile = window.innerWidth <= 768;
      this.$store.commit('SET_MOBILE', this.isMobile);
    },
    goToVip() {
      if (this.$route.path.indexOf('/registration/form') === 0) {
        this.$confirm('您正在进行报名，确认要退出吗？', '报名提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/events/registration')
        }).catch(() => {
          // 取消操作，停留在当前页面
        })
      }
      else if (this.$route.path !== '/members/aboutMembers') {
        this.$router.push('/members/aboutMembers');
      }
    },
    goToRegistration() {
      if (this.$route.path.indexOf('/registration/form') === 0) {
        this.$confirm('您正在进行报名，确认要退出吗？', '报名提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/events/registration')
        }).catch(() => {
          // 取消操作，停留在当前页面
        })
      } else if (this.$route.path !== '/events/registration') {
        this.$router.push('/events/registration');
      }
    },
    updateBreadcrumb() {
      const path = this.$route.path.split('/').filter(p => p);

      // 只取前两级路径
      const mainPath = path.slice(0, Math.min(2, path.length));

      // 生成面包屑
      this.breadcrumbItems = mainPath.map((item, index) => {
        const itemName = item.replace(/\d+/g, '').replace(/\/$/, '');
        return {
          name: this.breadcrumbMap[itemName]?.name || this.$t(itemName),
          link: '/' + path.slice(0, index + 1).join('/')
        };
      });
    },
    scrollToTop() {
      const container = document.querySelector('.global-scroll-container');
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }
};
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #333;
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-size: 16px;
  overflow-y: hidden;
  /* 添加垂直滚动条 */
  scrollbar-width: thin;
  /* 可选：为 Firefox 设置滚动条宽度 */
  scrollbar-color: #888 #f1f1f1;
  /* 可选：为 Firefox 设置滚动条颜色 */
}



.main-header {
  padding: 0 !important;
}


.floating-buttons {
  width: 120px;
  position: fixed;
  right: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: none;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  img {
    width: 40px;
    height: 40px;
    margin-bottom: 0;
  }

  p {
    font-size: var(--text-sm);
    margin: 0;
    line-height: 1;
  }
}

.floating-div {
  background-color: #F3F4FB;

  margin-left: 16px;
  margin-right: 16px;

  padding: 10px;

  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }

  cursor: pointer;
}

.floating-button {
  padding: 10px 20px;
  border: 2px solid #0056b3;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.floating-button:hover {
  background-color: #0056b3;
  border-color: #004085;
}




/* 外层滚动容器 */
.global-scroll-container {
  height: 100vh;
  overflow-y: auto;
}

.global-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: white;
}

/* 头部组样式 */
.header-group {
  flex-shrink: 0;

  .top-header {
    height: auto;
    padding: 0;
  }

  .main-header {
    padding: 0 calc(300px - 1.5rem);

    /* 抵消el-header默认padding */
    @media (max-width: 768px) {
      padding: 0;
    }
  }
}

.header-pc {
  padding: 0;
  height: 48px !important;
  padding-left: 300px !important;
  padding-right: 300px !important;
}

.el-header.main-header {
  position: relative;
  overflow: hidden;
  /* 隐藏横向溢出 */
  padding: 0 !important;
  /* 清除原有padding */
}

/* 主内容区 */
.main-content-pc {
  flex: 0 1 auto;
  /* 改为不扩展 */
  /* 关键属性 */
  padding-left: 300px !important;
  padding-right: 300px !important;
  display: flex;
  flex-direction: column;



  /* 处理Element UI默认样式 */
  :deep(.el-main__body) {
    padding: 0;
  }

  /* 确保内容宽度正确 */
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
}

/* 主内容区 */
.main-content {
  flex: 1 0 auto;
  /* 关键属性 */
  padding-left: 15px !important;
  padding-right: 15px !important;


  /* 处理Element UI默认样式 */
  :deep(.el-main__body) {
    padding: 0;
  }

  /* 确保内容宽度正确 */
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
}

/* 底部样式 */
.main-footer {
  flex-shrink: 0;
  padding: 0;
  margin-top: auto;
}



.el-card__body,
.el-main {
  padding-top: 0 !important;
}

/* 富文本内容通用样式 */
.rich-content {
  font-size: 14px;
  line-height: 1.6;
  padding: 16px;
  padding-left: 0;
  padding-right: 0;
  overflow-x: hidden;
  width: 100%;

  :deep(p) {
    margin-bottom: 1em;
    font-size: inherit;
  }

  :deep(h1, h2, h3, h4, h5, h6) {
    margin: 1.5em 0 0.8em;
    line-height: 1.4;
  }

  :deep(h1) {
    font-size: 2em;
  }

  :deep(h2) {
    font-size: 1.5em;
  }

  :deep(h3) {
    font-size: 1.25em;
  }

  :deep(h4) {
    font-size: 1.1em;
  }

}

.rich-content :deep(img) {
  max-width: 100% !important;
  height: auto !important;
  margin: 15px 0 !important;
}

.page-title {
  text-align: center;
  color: white;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 0;
  height: 40px;
  background-size: 100% 100%;

}

.result-title_bg {
  background-image: url('~@/assets/bg_title_result.jpg');
}

.news-title-bg {
  background-image: url('~@/assets/bg_title_news.jpg');
}

.about-header {
  background-image: url('~@/assets/bg_title_event.jpg');
  text-align: center;
  color: white;
  background-size: 100% 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 0;
  height: 40px;
}

.el-message {
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 300px !important;
  min-width: 300px !important;
  padding: 15px !important;
  border-radius: 4px !important;
  border-width: 0 !important;
  /* background: transparent !important; */

  .el-message__icon {
    display: none !important;
  }

  .el-message__content {
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
    white-space: nowrap !important;
    font-size: var(--text-base) !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}

.breadcrumb {
  padding-left: 1.2rem;
  font-size: var(--text-sm);
  color: #666666;
  background: #F3F4FB;
  height: 30px;
  align-items: center;
  display: flex;
  /* 添加 flex 布局 */
  margin-bottom: 12px;
}

.breadcrumb .separator {
  margin: 0 8px;
  color: #666666;
}

.breadcrumb .current {
  color: #666666;
}

.global-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 添加大屏适配 */
@media screen and (min-width: 1920px) {
  .global-scroll-container {
    height: 100vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .global-container {
    min-height: auto;
    height: auto;
    flex: 1;
  }

  .main-content-pc {
    flex: 0 1 auto;
    min-height: 50vh;

    transition: min-height 0.3s ease;
  }

}

/* 添加 1440x900 分辨率适配 */
@media screen and (max-width: 1440px) {
  html {
    font-size: 15px;
  }

  .header-pc {
    padding-left: 200px !important;
    padding-right: 200px !important;
  }

  .main-content-pc {
    padding-left: 200px !important;
    padding-right: 200px !important;
  }

  .main-header {
    padding: 0 calc(200px - 1.5rem) !important;
  }
}
/* 手机竖屏 */
@media (max-width: 768px) {
  html {
    font-size: 14px
  }

  .el-header {
    height: auto !important;
  }

  .page-title {
    margin-top: 16px !important;

  }

  .about-header {
    margin-top: 16px !important;
  }

  .el-card__body,
  .el-main {
    padding-top: 0 !important;
  }

  h1 {
    font-size: 1.8rem
  }

  .rich-content {
    font-size: 14px;
    padding: 0 10px;
    box-sizing: border-box;
  }


  .rich-content :deep(img) {
    width: 100% !important;
    margin: 15px 0 !important;
  }

  .floating-buttons {
    font-size: var(--text-sm);
    width: 90px !important;

    img {
      width: 30px !important;
      height: 30px !important;
      margin-bottom: 0;
    }
  }

  .floating-div {
    padding: 5px !important;
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .el-message {
    position: fixed !important;
    min-width:8rem !important;
    width: 12rem !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    top: 50% !important;
    padding: 15px !important;
    border-radius: 4px !important;
    border-width: 0 !important;
    margin: 0 !important;
    z-index: 9999 !important;
    box-sizing: border-box !important;
  }

  .el-message__icon {
    display: none !important;
  }

  .el-message__content {
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;        /* 原来是 40% */
    white-space: nowrap !important; /* 防止文字换行 */
    font-size: var(--text-base) !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}
/* 添加 1024x768 分辨率适配 */
@media screen and (max-width: 1024px) {
  html {
    font-size: 14px;
  }

  .header-pc {
    padding-left: 100px !important;
    padding-right: 100px !important;
  }

  .main-content-pc {
    padding-left: 100px !important;
    padding-right: 100px !important;
  }

  .main-header {
    padding: 0 calc(100px - 1.5rem) !important;
  }

  .floating-buttons {
    width: 100px;
    right: 10px;

    img {
      width: 35px;
      height: 35px;
    }
  }

  .floating-div {
    margin-left: 12px;
    margin-right: 12px;
    padding: 8px;
  }
}
</style>